import { useMemo } from 'react';
import { FEATURE_FLAGS } from 'src/constants';
import { isFeatureEnabled } from 'src/feature-flags';
import { getAvailablePublishers } from 'src/utils/publishers';
import type { CampaignDesiredStateDto } from 'src/store/generated/leela-api-generated';

/**
 * Hook that returns available publishers for the current user.
 * Google is shown when the ENABLE_GOOGLE_DEMANDGEN feature flag is on.
 *
 * The flag value is read on every render and used as the memo dependency, so the
 * list recomputes once Root.tsx populates the flag cache. Memoizing on [] would
 * freeze a google-less list when the hook first runs before flags arrive.
 */
export const useAvailablePublishers = (): Array<CampaignDesiredStateDto['publisher']> => {
  const googleEnabled = isFeatureEnabled(FEATURE_FLAGS.ENABLE_GOOGLE_DEMANDGEN);
  return useMemo(() => getAvailablePublishers(), [googleEnabled]);
};
